import { TeamMember } from "@models/teamMember.model";
import { httpRequest } from "../../http";
import { TeamMemberSerializer } from "@models/serializers/teamMemberSerializer";

export class CommandCreateTeamMember {
  async run(engagementId: number, body: TeamMember) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/team-members/`;
    try {
      const response = await httpRequest<any>(url, { method: "POST", body });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): TeamMember {
    const serializer = new TeamMemberSerializer();
    return serializer.deserialize(data);
  }
}
